import { gql, TypedDocumentNode } from "@apollo/client";

import { BlacklistElementFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment";
import { blacklistFragment } from "src/graphql/anti-fraud/fragments/BlacklistFragment";
import { elementFragment } from "src/graphql/anti-fraud/fragments/ElementFragment";
import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const blacklistElementFragment = gql`
  fragment BlacklistElement on BlacklistElement {
    id
    disabled
    typeCode
    properties {
      ...PropertyValueFragment
    }
    sourceCaseType {
      name
      code
    }
    blacklist {
      ...BlacklistFragment
    }
    adminStatus {
      ...AdminStatus
    }
    elements {
      ...ElementFragment
    }
    origin
  }

  ${blacklistFragment}
  ${propertyValueFragment}
  ${adminStatusFragment}
  ${elementFragment}
` as TypedDocumentNode<BlacklistElementFragment>;
